import React from 'react';
import { createRoot } from 'react-dom/client';
//import ReactDOM from 'react-dom';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import {applyMiddleware, compose, combineReducers, createStore} from 'redux';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

import reducer from './reducers';
import SettingsActions from './redux/SettingsActions';

import { AdmsRepository } from './redux/AdmsActions';
import ApiUtils from './liferay/ApiUtils';
import { getRecommendedLanguage } from './utils/langUtils';
import { makeSKSAUriNamespace } from './utils/uriUtil';
import i18n from './i18n';
import { I18nDumpTable } from "./i18n/showT";
import WebProtegeSettings from './webprotege/settings';
import XWikiSettings from './xwiki/settings';

//Соединение с REST сервисами
import { getPanel } from './utils/panelUtils';

import '../css/services.css';
import '../css/table.css';
import '../css/white.css';
import '../css/reset.css';
import '../css/documents.css';
import '../css/common.css';
import '../css/catalog.css';
import '../css/asset.css';
import '../css/csi.css';
import '../css/vowl.css';
import '../css/toolstyle.css';
import '../css/models.css';
//import '../css/bootstrap.css';
import { linker } from './redux/LinkerReducer';

global._babelPolyfill = false;

/** 
* Общая схема использования компонент:
* 1. Главная компонента App, которая определяет store и router для основного окна
* 2. Основное окно - панель ADMSPanel, которая содержит верхнее меню, содержимое и нижний статус бар
* 3. Содержимое определено в компонентах из каталога components. MainComponent - для отображения и редактирования справочников.
* 4. MainComponent используется представления (views) для отобрадения списка значений или формы создания/редактирования
*/
const middlewares = [];
if (process.env.NODE_ENV === 'development') {
	const {logger} = require('redux-logger');
	//Для полного логирование добавить middlewares.push(logger);
	//middlewares.push(logger);
}
middlewares.push(thunk);
const store = composeWithDevTools(applyMiddleware(...middlewares))(createStore)(reducer);

const Application = () => {
	//Сразу определим язык интерфейса и переключим i18n
	const language = getRecommendedLanguage();	
	i18n.changeLanguage(language);
	const sksaNamespace = makeSKSAUriNamespace();

	console.log("App (Application) ", language, sksaNamespace, ApiUtils.isSignedIn(), ApiUtils.getUserId());
	AdmsRepository.setDefaultCatalog(!ApiUtils.isSignedIn());

	store.dispatch(SettingsActions.LANG(language));
	store.dispatch(SettingsActions.NAMESPACE("sksa", sksaNamespace));
	if (process.env.NODE_ENV === 'development') {
		console.log("App (Application) stage 2 ", process.env.NODE_ENV, navigator.language, language);
		//Варианты 
		//store.dispatch(SettingsActions.getUserGroups());
		store.dispatch(SettingsActions.GROUPS({Operator: true, PowerUser: true, Demo: false, Expert: true}));
		store.dispatch(SettingsActions.NAMESPACE("sksa", "http://purl.semanticpro.org/sksa/"));
		//false - приватный каталог 
		AdmsRepository.setDefaultCatalog(false);
		//<I18nDumpTable />
	};
	
	if (ApiUtils.isLifeRayPresent()){
		store.dispatch(SettingsActions.SIGNED(ApiUtils.isSignedIn()));
		store.dispatch(SettingsActions.getUserGroups());
	}
	//Для вывода таблицы с локализованным значениям убрать комментирование строки ниже
	//if (2==2) return ( <I18nDumpTable /> );
	const PanelComponent = getPanel();
	return (
		// <I18nDumpTable />
		<Provider store={store}>
			<HashRouter
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
				<PanelComponent />
			</HashRouter>
		</Provider>
	)
}

//ReactDOM.render(<Application />, document.getElementById('catalog_app'));
createRoot(document.getElementById('catalog_app')).render(<Application />);